export default __webpack_public_path__ + "static/media/latest-news-img22.e6b44b72.jpg";